module.exports = __webpack_public_path__ + "resources/img/img-solution-hxp.09f01b6d.jpg";